namespace Areas.Staff.DesignList {
    "use strict";

    let requestLogId: number;
    let runQuery: boolean = false;

    export function onDesignListGridSelectionChanged(e) {
        const rowSelected = e.selectedRowsData.length === 1;

        if (rowSelected) {
            const status: string = e.selectedRowsData[0].emailDateTime;
            const canBeModified = (status !== null);

            if (!canBeModified) {
                enableButton("EditDesignButton");
            } else {
                disableButton("EditDesignButton");
            }
        }
    }


    export function viewEditLinkDesignList(cellElement: any, cellInfo: any) {
        const getData = () => { return cellInfo.data.designListRequestLogId; };
        
        if (status == null) {
            buildCellContent(cellElement, getData, "<a href= '/Staff/DesignList/Edit/{placeholder}' target=\"_blank\">Edit</a>");
        } else {
            buildCellContent(cellElement, getData, "<a href= '/Staff/DesignList/View/{placeholder}' >View</a>");
        }
    }

    export function viewDesignList() {

        var dataGrid = $('#DesignListGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        requestLogId = dataId; 
        if (dataId != null) {
            var linkInfo = "/Staff/DesignList/View/" + dataId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }

    }

    export function editDesignList() {
        var dataGrid = $('#DesignListGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            var linkInfo = "/Staff/DesignList/Edit/" + dataId.toString() + "";
            location.href = linkInfo;
        } else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function addDesignList() {
        const createDesignConsultantListDialog = new Areas.Dialogs.CreateDesignConsultantListDialog(() => { });
    }

    export function goToEditFromForm() {
        var keyId: any = $('#ListLogForm').dxForm('instance').option('KeyId');
        if (keyId != null) {
            var linkInfo = "/Staff/DesignList/Edit/" + keyId.toString() + "";
            location.href = linkInfo;
        }
    }

    export function getRequestLogIdFromForm() {
        var keyId: any = $('#ListLogForm').dxForm('instance').option('KeyId');
        requestLogId = keyId;
    }

    export function getDesignList() {
        runQuery = true;

        var data: any = $('#ListLogForm').dxForm('instance').option('formData');
        requestLogId = data.DesignListRequestLogId;

        enableButton("ProcessButton");
        saveDesignListLog();   //callback refreshes grid

        Areas.refreshGrid("DesignListResultGrid");

    }

    export function processDesignList() {

        disableButton("ProcessButton");
        disableButton("PreviewButton");

        const mainForm = $("#ListLogForm").dxForm("instance");
        const newData: any = mainForm.option("formData");
        const result: any = mainForm.validate();


        if (result.isValid) {

            //Specialty   &  Options
            const specialtyGrid = $("#SpecialtyGrid").dxDataGrid("instance");
            const workCapabilityGrid = $("#WorkCapabilityGrid").dxDataGrid("instance");

            var types = specialtyGrid.getSelectedRowKeys();
            var options = workCapabilityGrid.getSelectedRowKeys();
            var requestLogId = specialtyGrid.option("RequestLogId");

            var projectNumber = newData.RequestRecord.ProjectNumber;
            var projectName = newData.RequestRecord.ProjectName;
            var ccEmail = newData.RequestRecord.CCEmail;
            var vendorBidRangeTypeLk = newData.RequestRecord.VendorBidRangeTypeLk;
            var note = newData.RequestRecord.Note;
            var requestStatus = newData.RequestRecord.RequestStatus;

            var data: any = {
                RequestLogFormData: JSON.stringify(newData.RequestRecord),
                RequestLogId: requestLogId,
                DesignListRequestLogId: requestLogId,
                ProjectNumber: projectNumber,
                ProjectName: projectName,
                CCEmail: ccEmail,
                BidRangeTypeLk: vendorBidRangeTypeLk,
                Note: note,
                RequestStatus: requestStatus,
                SpecialtyCodes: types,
                OptionTypeIds: options
            };
            sendRequest(`/Staff/DesignList/ProcessDesignListRequest/${requestLogId}`, JSON.stringify(data), "PUT", () => { Areas.Staff.DesignList.goToDesignList() });
        }

        
    }

    export function canExecuteQuery() {
        return runQuery;
    }

    export function getRequestLogId() {
        return requestLogId;
    }


    export function goToDesignList() {

        var linkInfo = "/Staff/DesignList/Index";
        location.href = linkInfo;

    }

    export function saveDesignListLog() {
        const mainForm = $("#ListLogForm").dxForm("instance");
        const newData: any = mainForm.option("formData");
        const result: any = mainForm.validate();


        if (result.isValid) {

            //Specialty   &  Options
            const specialtyGrid = $("#SpecialtyGrid").dxDataGrid("instance");
            const workCapabilityGrid = $("#WorkCapabilityGrid").dxDataGrid("instance");

            var types = specialtyGrid.getSelectedRowKeys();
            var options = workCapabilityGrid.getSelectedRowKeys();
            var requestLogId = specialtyGrid.option("RequestLogId");

            var projectNumber = newData.RequestRecord.ProjectNumber;
            var projectName = newData.RequestRecord.ProjectName;
            var ccEmail = newData.RequestRecord.CCEmail;
            var vendorBidRangeTypeLk = newData.RequestRecord.VendorBidRangeTypeLk;
            var note = newData.RequestRecord.Note;
            var requestStatus = newData.RequestRecord.RequestStatus;

            var data: any = {
                RequestLogFormData: JSON.stringify(newData.RequestRecord),
                RequestLogId: requestLogId,
                DesignListRequestLogId: requestLogId,
                ProjectNumber: projectNumber,
                ProjectName: projectName,
                CCEmail: ccEmail,
                BidRangeTypeLk: vendorBidRangeTypeLk,
                Note: note,
                RequestStatus: requestStatus,
                SpecialtyCodes: types,
                OptionTypeIds: options
            };
            sendRequest("/Staff/DesignList/Put", JSON.stringify(data), "PUT", () => {  });
        }

    }
   

    //Speciality
    export function onSpecialtyGridContentReady(e: any) {
        var requestLogId = e.component.option("RequestLogId") as number;
        getLogLogSpecialtyCodes(requestLogId);
    }

    export function getLogLogSpecialtyCodes(requestLogId: number) {
        var checkGrid = $("#SpecialtyGrid").dxDataGrid("instance");

        $.ajax({
            url: `/Staff/DesignList/GetLogLogSpecialtyCodes/${requestLogId}`,
            method: "GET",
            contentType: "application/json",
            success: (data) => {
                checkGrid.selectRows(data, false);
            },
            error: () => {
                DevExpress.ui.notify("Error getting specialty codes for Design List Log.", "error", 2000);
            }
        });
    }

    //Work Capability
    export function onDesignListWorkCapabilityGridContentReady(e: any) {
        var requestLogId = e.component.option("RequestLogId") as number;
        getDesignListWorkCapabilities(requestLogId);
    }

    export function getDesignListWorkCapabilities(requestLogId: number) {
        var checkGrid = $("#WorkCapabilityGrid").dxDataGrid("instance");

        $.ajax({
            url: `/Staff/DesignList/GetDesignListWorkCapabilities/${requestLogId}`,
            method: "GET",
            contentType: "application/json",
            success: (data) => {
                checkGrid.selectRows(data, false);
            },
            error: () => {
                DevExpress.ui.notify("Error getting bid option types for Design List Log.", "error", 2000);
            }
        });
    }

    export function viewVendorLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.vendorId; },
            "<a href= '/Vendor/ViewPrint/Index/{placeholder}' target=\"_blank\">View</a>");
    }

}